export interface EnvCfg {
	MODE: "development" | "production";
	SCREENSHOT_ACCEPT_LOCALSTORAGE_KEY: string;
	LIVE_VIEW_HEARTBEAT_TIMEOUT_MS: number;
	LIVE_VIEW_HEARTBEAT_INTERVAL: number;
	CLASSWIZE_GTM_ID: string;
	POSTHOG_KEY: string;
	POSTHOG_HOST: string;
	DATADOG_URL: string;
	DATADOG_CLIENT_TOKEN: string;
	DATADOG_RUM_ENABLED: boolean;
	DATADOG_RUM_APP_ID: string;
	DATADOG_RUM_SERVICE_NAME: string;
	DATADOG_RUM_SAMPLE_RATE: number;
	DATADOG_LOGGING_ENABLED: boolean;
	DATADOG_LOGGER_SERVICE_NAME: string;
	DATADOG_LOGGER_SESSION_SAMPLE_RATE: number;
	MAX_FOCUS_NAME_LENGTH: number;
	MAX_FOCUSES_IN_LIBRARY: number;
	MAX_STUDENTS: number;
	MONITOR_MODE_MAX_STUDENTS: number;
	COURSES_MFE_URL_SIT: string;
	COURSES_MFE_URL_STG: string;
	COURSES_MFE_URL_AUSE1: string;
	COURSES_MFE_URL_USCE1: string;
	COURSES_MFE_URL_EUWE2: string;
	ACADEMY_MFE_URL_SIT: string;
	ACADEMY_MFE_URL_PRD: string;
	ACADEMY_MFE_URL_OVERRIDE: string;
	ACADEMY_API_URL_AU: string;
	ACADEMY_API_URL_US: string;
	ACADEMY_API_URL_UK: string;
	ACADEMY_API_URL_SIT: string;
	ACADEMY_API_URL_OVERRIDE: string;
	COURSES_API_URL_SIT: string;
	COURSES_API_URL_STG: string;
	COURSES_API_URL_AUSE1: string;
	COURSES_API_URL_USCE1: string;
	COURSES_API_URL_EUWE2: string;
	CLASSROOM_API_URL_SIT: string;
	CLASSROOM_API_URL_STG: string;
	CLASSROOM_API_URL_AUSE1: string;
	CLASSROOM_API_URL_USCE1: string;
	CLASSROOM_API_URL_EUWE2: string;
	PYTHON_BACKEND_URL_SIT: string;
	PYTHON_BACKEND_URL_STG: string;
	PYTHON_BACKEND_URL_AUSE1: string;
	PYTHON_BACKEND_URL_USCE1: string;
	PYTHON_BACKEND_URL_EUWE2: string;
	SCREENSHARE_VIEWER_URL_SIT: string;
	SCREENSHARE_VIEWER_URL_STG: string;
	SCREENSHARE_VIEWER_URL_AUSE1: string;
	SCREENSHARE_VIEWER_URL_USCE1: string;
	SCREENSHARE_VIEWER_URL_EUWE2: string;
	CLASSROOM_SCREENSHOTS_API_SIT: string;
	CLASSROOM_SCREENSHOTS_API_STG: string;
	CLASSROOM_SCREENSHOTS_API_AUSE1: string;
	CLASSROOM_SCREENSHOTS_API_USCE1: string;
	CLASSROOM_SCREENSHOTS_API_EUWE2: string;
	BUILD_VERSION: string;

	COURSES_MFE_URL_OVERRIDE: string;
	COURSES_API_URL_OVERRIDE: string;
	CLASSROOM_API_URL_OVERRIDE: string;
	PYTHON_BACKEND_URL_OVERRIDE: string;
	CLASSROOM_SCREENSHOTS_API_OVERRIDE: string;
	SCREENSHARE_VIEWER_URL_OVERRIDE: string;
}

export const envConfig: EnvCfg = {
	MODE: import.meta.env.MODE as "development" | "production",

	SCREENSHOT_ACCEPT_LOCALSTORAGE_KEY: import.meta.env.VITE_SCREENSHOT_ACCEPT_LOCALSTORAGE_KEY as string,
	LIVE_VIEW_HEARTBEAT_TIMEOUT_MS: Number(import.meta.env.VITE_LIVE_VIEW_HEARTBEAT_TIMEOUT_MS),
	LIVE_VIEW_HEARTBEAT_INTERVAL: Number(import.meta.env.VITE_LIVE_VIEW_HEARTBEAT_INTERVAL),

	CLASSWIZE_GTM_ID: import.meta.env.VITE_CLASSWIZE_GTM_ID as string,

	POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY as string,
	POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST as string,

	DATADOG_URL: import.meta.env.VITE_DATADOG_URL as string,
	DATADOG_CLIENT_TOKEN: import.meta.env.VITE_DATADOG_CLIENT_TOKEN as string,
	DATADOG_RUM_ENABLED: import.meta.env.VITE_DATADOG_RUM_ENABLED as boolean,
	DATADOG_RUM_APP_ID: import.meta.env.VITE_DATADOG_RUM_APP_ID as string,
	DATADOG_RUM_SERVICE_NAME: import.meta.env.VITE_DATADOG_RUM_SERVICE_NAME as string,
	DATADOG_RUM_SAMPLE_RATE: Number(import.meta.env.VITE_DATADOG_RUM_SAMPLE_RATE),
	DATADOG_LOGGING_ENABLED: import.meta.env.VITE_DATADOG_LOGGING_ENABLED as boolean,
	DATADOG_LOGGER_SERVICE_NAME: import.meta.env.VITE_DATADOG_LOGGER_SERVICE_NAME as string,
	DATADOG_LOGGER_SESSION_SAMPLE_RATE: Number(import.meta.env.VITE_DATADOG_LOGGER_SESSION_SAMPLE_RATE),

	MAX_FOCUS_NAME_LENGTH: Number(import.meta.env.VITE_MAX_FOCUS_NAME_LENGTH),
	MAX_FOCUSES_IN_LIBRARY: Number(import.meta.env.VITE_MAX_FOCUSES_IN_LIBRARY),
	MAX_STUDENTS: Number(import.meta.env.VITE_MAX_STUDENTS),
	MONITOR_MODE_MAX_STUDENTS: Number(import.meta.env.VITE_MONITOR_MODE_MAX_STUDENTS),

	COURSES_MFE_URL_SIT: import.meta.env.VITE_COURSES_MFE_URL_SIT as string,
	COURSES_MFE_URL_STG: import.meta.env.VITE_COURSES_MFE_URL_STG as string,
	COURSES_MFE_URL_AUSE1: import.meta.env.VITE_COURSES_MFE_URL_AUSE1 as string,
	COURSES_MFE_URL_USCE1: import.meta.env.VITE_COURSES_MFE_URL_USCE1 as string,
	COURSES_MFE_URL_EUWE2: import.meta.env.VITE_COURSES_MFE_URL_EUWE2 as string,
	COURSES_MFE_URL_OVERRIDE: import.meta.env.VITE_COURSES_MFE_URL_OVERRIDE as string,

	ACADEMY_MFE_URL_SIT: import.meta.env.VITE_ACADEMY_MFE_URL_SIT as string,
	ACADEMY_MFE_URL_PRD: import.meta.env.VITE_ACADEMY_MFE_URL_PRD as string,
	ACADEMY_MFE_URL_OVERRIDE: import.meta.env.VITE_ACADEMY_MFE_URL_OVERRIDE as string,

	ACADEMY_API_URL_AU: import.meta.env.VITE_ACADEMY_API_AU as string,
	ACADEMY_API_URL_US: import.meta.env.VITE_ACADEMY_API_US as string,
	ACADEMY_API_URL_UK: import.meta.env.VITE_ACADEMY_API_UK as string,
	ACADEMY_API_URL_SIT: import.meta.env.VITE_ACADEMY_API_SIT as string,
	ACADEMY_API_URL_OVERRIDE: import.meta.env.VITE_ACADEMY_API_URL_OVERRIDE as string,

	COURSES_API_URL_SIT: import.meta.env.VITE_COURSES_API_URL_SIT as string,
	COURSES_API_URL_STG: import.meta.env.VITE_COURSES_API_URL_STG as string,
	COURSES_API_URL_AUSE1: import.meta.env.VITE_COURSES_API_URL_AUSE1 as string,
	COURSES_API_URL_USCE1: import.meta.env.VITE_COURSES_API_URL_USCE1 as string,
	COURSES_API_URL_EUWE2: import.meta.env.VITE_COURSES_API_URL_EUWE2 as string,
	COURSES_API_URL_OVERRIDE: import.meta.env.VITE_COURSES_API_URL_OVERRIDE as string,

	CLASSROOM_API_URL_SIT: import.meta.env.VITE_CLASSROOM_API_URL_SIT as string,
	CLASSROOM_API_URL_STG: import.meta.env.VITE_CLASSROOM_API_URL_STG as string,
	CLASSROOM_API_URL_AUSE1: import.meta.env.VITE_CLASSROOM_API_URL_AUSE1 as string,
	CLASSROOM_API_URL_USCE1: import.meta.env.VITE_CLASSROOM_API_URL_USCE1 as string,
	CLASSROOM_API_URL_EUWE2: import.meta.env.VITE_CLASSROOM_API_URL_EUWE2 as string,
	CLASSROOM_API_URL_OVERRIDE: import.meta.env.VITE_CLASSROOM_API_URL_OVERRIDE as string,

	PYTHON_BACKEND_URL_SIT: import.meta.env.VITE_PYTHON_BACKEND_URL_SIT as string,
	PYTHON_BACKEND_URL_STG: import.meta.env.VITE_PYTHON_BACKEND_URL_STG as string,
	PYTHON_BACKEND_URL_AUSE1: import.meta.env.VITE_PYTHON_BACKEND_URL_AUSE1 as string,
	PYTHON_BACKEND_URL_USCE1: import.meta.env.VITE_PYTHON_BACKEND_URL_USCE1 as string,
	PYTHON_BACKEND_URL_EUWE2: import.meta.env.VITE_PYTHON_BACKEND_URL_EUWE2 as string,
	PYTHON_BACKEND_URL_OVERRIDE: import.meta.env.VITE_PYTHON_BACKEND_URL_OVERRIDE as string,

	SCREENSHARE_VIEWER_URL_SIT: import.meta.env.VITE_SCREENSHARE_VIEWER_URL_SIT as string,
	SCREENSHARE_VIEWER_URL_STG: import.meta.env.VITE_SCREENSHARE_VIEWER_URL_STG as string,
	SCREENSHARE_VIEWER_URL_AUSE1: import.meta.env.VITE_SCREENSHARE_VIEWER_URL_AUSE1 as string,
	SCREENSHARE_VIEWER_URL_USCE1: import.meta.env.VITE_SCREENSHARE_VIEWER_URL_USCE1 as string,
	SCREENSHARE_VIEWER_URL_EUWE2: import.meta.env.VITE_SCREENSHARE_VIEWER_URL_EUWE2 as string,
	SCREENSHARE_VIEWER_URL_OVERRIDE: import.meta.env.VITE_SCREENSHARE_VIEWER_URL_OVERRIDE as string,

	CLASSROOM_SCREENSHOTS_API_SIT: import.meta.env.VITE_CLASSROOM_SCREENSHOTS_API_SIT as string,
	CLASSROOM_SCREENSHOTS_API_STG: import.meta.env.VITE_CLASSROOM_SCREENSHOTS_API_STG as string,
	CLASSROOM_SCREENSHOTS_API_AUSE1: import.meta.env.VITE_CLASSROOM_SCREENSHOTS_API_AUSE1 as string,
	CLASSROOM_SCREENSHOTS_API_USCE1: import.meta.env.VITE_CLASSROOM_SCREENSHOTS_API_USCE1 as string,
	CLASSROOM_SCREENSHOTS_API_EUWE2: import.meta.env.VITE_CLASSROOM_SCREENSHOTS_API_EUWE2 as string,
	CLASSROOM_SCREENSHOTS_API_OVERRIDE: import.meta.env.VITE_CLASSROOM_SCREENSHOTS_API_OVERRIDE as string,

	BUILD_VERSION: import.meta.env.VITE_BUILD_VERSION as string,
};
